import r from "./_baseToString.js";
function o(t) {
  return t == null ? "" : r(t);
}
export {
  o as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/toString.js
// module id = 318
// module chunks = 67